import { CompanyRepository } from "core/repository";
import { Base2Presenter } from "core/presenter";

class CustomInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: true,
      customer_custom_fields: []
    };
  }

  async onStart() {
    const currentUser = await this.mRuntime.get("currentUser");
    const result = await CompanyRepository.get(currentUser.company_uuid, true);

    if (result.success) {
      this.enqueue({
        customer_custom_fields: result.data.customer_custom_fields
      });
    }

    this.enqueue({ loading: false });
  }
}

export default CustomInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/custom-info/presenter.js